import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getControlBasic } from '../Api'

export default generateApiAction({
  baseType: Types.CONTROLS.GET.BASIC,
  api: getControlBasic,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/controls/GetBasicAction.js